// import { Outlet } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Navbar from "../src/components/Navbar";

// function App() {
//   return (

//     <div>

//       <Navbar />

//       <Outlet />

//     </div>

//   );
// }

// export default App;

import React from 'react';
import {
  HashRouter,
  Routes,
  Route,
} from "react-router-dom";
import './index.css';
import { Outlet } from 'react-router-dom';
import Navbar from "../src/components/Navbar";
import Home from "./pages/home";
import YourWork from "./pages/yourWork";
import Misc from "./pages/misc";
import Project1 from './pages/project1';
import Project2 from './pages/project2';
import Project3 from './pages/project3';
import 'bootstrap/dist/css/bootstrap.min.css';



function App() {
  return (

    <HashRouter>

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="yourWork" element={<YourWork />} />
        <Route path="misc" element={<Misc />} />
        <Route path="yourWork/projectOne" element={<Project1 />} />
        <Route path="yourWork/projectTwo" element={<Project2 />} />
        <Route path="yourWork/projectThree" element={<Project3 />} />
      </Routes>

      <Outlet />
    </HashRouter>

  )
}

export default App;